import React from 'react';
// eslint-disable-next-line import/no-unresolved
import scrumSVG from 'assets/resources/icon/scrum_icon.svg';

import OptimizedImage from '../OptimizedImage';
import ImgHTML from '../ImgHTML';

const IndustriesScrum = () => {
  return (
    <div className="col-lg-4 col-md-12">
      <div className="right-beam">
        <OptimizedImage
          src="pages/scrum_photo.png"
          className="img-fluid img-head"
          alt="scrum photo"
          title='scrum photo'
        />
        <div className="basis">
          <div className="icon">
            <ImgHTML src={scrumSVG} alt="scrum svg icon" />
          </div>
          <div className="content">
            <p>
              All the great software we create is in accordance with a
              standardized workflow and <span>Scrum methodology.</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndustriesScrum;
